import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input', 'results', 'hidden']

  connect() {
    this._timer = null
    this._url = this.data.get('url')
    this._onDocClick = (e) => { if (!this.element.contains(e.target)) this.hide() }
    document.addEventListener('click', this._onDocClick)
  }

  disconnect() {
    document.removeEventListener('click', this._onDocClick)
  }

  onInput() {
    clearTimeout(this._timer)
    this.hiddenTarget.value = '' // typing invalidates the previous pick
    const q = this.inputTarget.value.trim()
    if (q.length < 1) { this.hide(); return }
    this._timer = setTimeout(() => this.search(q), 250)
  }

  async search(q) {
    try {
      const res = await fetch(`${this._url}?q=${encodeURIComponent(q)}`, { headers: { Accept: 'application/json' } })
      this.render(await res.json())
    } catch (e) { this.hide() }
  }

  render(items) {
    if (!items || !items.length) {
      this.resultsTarget.innerHTML = `<div class="px-3 py-2 text-[12px] text-slate-400">${this.data.get('empty') || ''}</div>`
      this.show(); return
    }
    this.resultsTarget.innerHTML = items.map((c) => {
      const sub = [c.company, c.email].filter(Boolean).map((s) => this.esc(s)).join(' · ')
      return `<button type="button" data-action="crm-contact-ac#pick" data-id="${c.id}" data-name="${this.esc(c.name)}"
        class="w-full text-left px-3 py-2 hover:bg-slate-50 border-b border-slate-50 last:border-0">
        <div class="text-[13px] text-slate-800 truncate">${this.esc(c.name)}</div>
        ${sub ? `<div class="text-[11px] text-slate-400 truncate">${sub}</div>` : ''}
      </button>`
    }).join('')
    this.show()
  }

  pick(e) {
    const b = e.currentTarget
    this.hiddenTarget.value = b.dataset.id
    this.inputTarget.value = b.dataset.name
    this.hide()
  }

  show() { this.resultsTarget.classList.remove('hidden') }
  hide() { this.resultsTarget.classList.add('hidden') }

  esc(s) {
    return (s || '').replace(/[&<>"]/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]))
  }
}
